import { Client } from '@microsoft/microsoft-graph-client';
import { AzureGroupType, AzureUser } from '../entities/formTemplateDataType';
import { useEffect, useState } from 'react';

export const azureGroupService = async (accessToken: string): Promise<string[]> => {
    const client = Client.init({
        authProvider: done => {
            done(null, accessToken);
        },
    });

    try {
        const response = await client.api('/me/memberOf').get();
        return response.value?.map((group: AzureGroupType) => group.displayName) ?? [];
    } catch (error) {
        console.error('Error fetching user groups:', error);
        return [];
    }
};

export const getAzureUserProfile = async (accessToken: string): Promise<AzureUser|null> => {
    const client = Client.init({
        authProvider: done => {
            done(null, accessToken);
        },
    });

    try {
        const response = await client.api('/me').get();
        return response;
    } catch (error) {
        console.error('Error fetching user:', error);
        return null;
    }
}

export const azureUserService = async (accessToken: string) => {
    const client = Client.init({
        authProvider: done => {
            done(null, accessToken);
        },
    });

    try {
        const response = await client.api('/me').get();
        return response;
    } catch (error) {
        console.error('Error fetching user:', error);
        return [];
    }
};

export const searchAZUsers = async (accessToken: string, search: string): Promise<AzureUser[]> => {
    if (!accessToken) {
        return [];
    }

    const client = Client.init({
        authProvider: done => { done(null, accessToken);},
    });

    try {
        const response = await client.api(`/users?$filter=startswith(displayName,'${search}') or startswith(mail,'${search}') 
            or startswith(givenName,'${search}') or startswith(surname,'${search}') 
            or startswith(userPrincipalName,'${search}')`).get();
        
        return response?.value ?? [];
    } catch (error) {
        console.error('Error search AZ users:', error);
        return [];
    }
}

export const useAZUserSearch = (accessToken: string, search: string) => {
    const [users, setUsers] = useState<AzureUser[]>([]);
    const [error, setErrors] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        let timeoutId: NodeJS.Timeout = null;
        if (search?.length < 3 || !accessToken) {
            setUsers([]);
            setLoading(false);
        } else {
            timeoutId = setTimeout(async () => {
                try {
                    const urs = await searchAZUsers(accessToken, search);
                    setUsers(urs);
                } catch (error) {   
                    setErrors(error);
                } finally {
                    setLoading(false);
                }
            }, 500);
        }

        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [search, accessToken]);

    return { users, error, loading };
}

